import SessionAreaChart from './SessionAreaChart';

export default SessionAreaChart;
